// extracted by mini-css-extract-plugin
export var phone = "_2b-0";
export var phoneDragging = "_2b-1";